import { Injectable } from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot, TitleStrategy} from "@angular/router";
import {Title} from "@angular/platform-browser";

@Injectable({
  providedIn: 'root'
})
export class TitleResolverService extends TitleStrategy {
  override updateTitle(snapshot: RouterStateSnapshot) {
    //todo: @Roland translation and theme switch needed
      this.title.setTitle('AdvoFin Prozessfinanzierungs AG - Registrierung');
  }
  constructor(private title: Title) {
    super();
  }
}
